import * as z from 'zod';
import { Get as Get$1, Close as Close$1 } from './contract/contract-surety-bond.dto.mjs';
import * as contractSuretyBond_dto from './contract/contract-surety-bond.dto.mjs';
export { contractSuretyBond_dto as Contract };
import * as suretyBondPreview_dto from './preview/surety-bond-preview.dto.mjs';
export { suretyBondPreview_dto as Preview };

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.discriminatedUnion("suretyType", [Get$1.Response.schema]);
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Close;
(function (Close) {
    (function (Request) {
        Request.schema = z.discriminatedUnion("suretyType", [Close$1.Request.schema]);
    })(Close.Request || (Close.Request = {}));
})(Close || (Close = {}));

export { Close, Get };
